<template>
  <v-card
    tile
  >
    <v-img
      :src="cardImage"
    />
    <v-card-title>
      マインクラフトではじめるプログラミング２
    </v-card-title>
    <v-card-subtitle>
      マインクラフトをプレイしながら学べるプログラミングの入門書の第二弾
    </v-card-subtitle>
    <v-card-text>
      プログラミングがはじめてのお子さま向けのマインクラフトでまなぶプログラミングの教科書の第二弾です<br/>前回の内容を踏まえて更にプログラミングでマインクラフトの世界を遊び倒します
    </v-card-text>
    <v-card-actions>
      <a href="/textbooks/minecraft2/">
        <v-btn
          color="purple"
          text
        >
          無料で読む
        </v-btn>
      </a>
    </v-card-actions>
  </v-card>
</template>

<script>
import MineCraftTextBookImage from '@/assets/img/textbooks/minecraft_programming_for_children2.jpg'

export default {
  name: 'VMinecraftProgrammingForChildren2',
  data() {
    return {
      cardImage: MineCraftTextBookImage
    }
  }
}
</script>